import React, { useEffect, useState } from "react";
import AdminSidebar from "../components/AdminSidebar";
import AdminNavbar from "../components/AdminNavbar";
import AdminAPI from "../../services/adminApi";
import { toast } from "react-toastify";

function Cycles() {
  const [cycles, setCycles] = useState([]);
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");

  const [createForm, setCreateForm] = useState({
    farmer_id: "",
    total_days: 60,
    current_phase: "",
    notes: ""
  });

  useEffect(() => {
    fetchCycles();
  }, []);

  const fetchCycles = async () => {
    try {
      const res = await AdminAPI.get(
        `/cycles?search=${search}&status=${status}`
      );
      setCycles(res.data);
    } catch (err) {
      console.log(err);
      toast.error("Failed to fetch cycles");
    }
  };

  const handleCreateChange = (e) => {
    setCreateForm({
      ...createForm,
      [e.target.name]: e.target.value
    });
  };

  const createCycle = async (e) => {
    e.preventDefault();

    try {
      await AdminAPI.post("/cycles", createForm);

      toast.success("Cycle created successfully");

      setCreateForm({
        farmer_id: "",
        total_days: 60,
        current_phase: "",
        notes: ""
      });

      fetchCycles();

    } catch (err) {
      console.log(err);
      toast.error("Failed to create cycle");
    }
  };

  const updateCycleAction = async (type, id) => {
    try {
      await AdminAPI.put(`/cycles/${type}/${id}`);

      toast.success(`Cycle ${type} successful`);

      fetchCycles();

    } catch (err) {
      console.log(err);
      toast.error(`Failed to ${type} cycle`);
    }
  };

  const deleteCycle = async (id) => {
    const confirmDelete = window.confirm(
      "Delete this cycle?"
    );

    if (!confirmDelete) return;

    try {
      await AdminAPI.delete(`/cycles/${id}`);

      toast.success("Cycle deleted");

      fetchCycles();

    } catch (err) {
      console.log(err);
      toast.error("Delete failed");
    }
  };

  return (
    <div className="d-flex">
      <AdminSidebar />

      <div
        style={{
          flex: 1,
          background: "#f5f7fa",
          minHeight: "100vh",
          padding: "20px"
        }}
      >
        <AdminNavbar />

        {/* CREATE CYCLE */}
        <div className="card shadow border-0 mt-4">
          <div className="card-body">
            <h4>Create New Cycle</h4>

            <form
              onSubmit={createCycle}
              className="row g-3 mt-2"
            >
              <div className="col-md-3">
                <input
                  type="number"
                  name="farmer_id"
                  className="form-control"
                  placeholder="Farmer ID"
                  value={createForm.farmer_id}
                  onChange={handleCreateChange}
                  required
                />
              </div>

              <div className="col-md-2">
                <input
                  type="number"
                  name="total_days"
                  className="form-control"
                  value={createForm.total_days}
                  onChange={handleCreateChange}
                />
              </div>

              <div className="col-md-3">
                <input
                  type="text"
                  name="current_phase"
                  className="form-control"
                  placeholder="Current Phase"
                  value={createForm.current_phase}
                  onChange={handleCreateChange}
                />
              </div>

              <div className="col-md-3">
                <input
                  type="text"
                  name="notes"
                  className="form-control"
                  placeholder="Notes"
                  value={createForm.notes}
                  onChange={handleCreateChange}
                />
              </div>

              <div className="col-md-1">
                <button className="btn btn-success w-100">
                  Add
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* FILTERS */}
        <div className="card shadow border-0 mt-4">
          <div className="card-body">
            <div className="d-flex gap-3 flex-wrap">
              <input
                type="text"
                className="form-control"
                style={{ width: "300px" }}
                placeholder="Search farmer..."
                value={search}
                onChange={(e) =>
                  setSearch(e.target.value)
                }
              />

              <select
                className="form-select"
                style={{ width: "220px" }}
                value={status}
                onChange={(e) =>
                  setStatus(e.target.value)
                }
              >
                <option value="">All Status</option>
                <option value="active">Active</option>
                <option value="paused">Paused</option>
                <option value="completed">Completed</option>
              </select>

              <button
                className="btn btn-primary"
                onClick={fetchCycles}
              >
                Search
              </button>
            </div>
          </div>
        </div>

        {/* TABLE */}
        <div className="card shadow border-0 mt-4">
          <div className="card-body">
            <h4>Cycle Management</h4>

            <div className="table-responsive mt-3">
              <table className="table table-bordered table-hover">
                <thead className="table-success">
                  <tr>
                    <th>Farmer</th>
                    <th>Current Day</th>
                    <th>Total Days</th>
                    <th>Phase</th>
                    <th>Health</th>
                    <th>Consistency</th>
                    <th>Status</th>
                    <th>Started</th>
                    <th width="420">Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {cycles.map((cycle) => (
                    <tr key={cycle.id}>
                      <td>{cycle.full_name}</td>
                      <td>{cycle.current_day}</td>
                      <td>{cycle.total_days}</td>
                      <td>{cycle.current_phase}</td>
                      <td>{cycle.health_score}%</td>
                      <td>{cycle.consistency_rate}%</td>

                      <td>
                        <span
                          className={`badge ${
                            cycle.status === "active"
                              ? "bg-success"
                              : cycle.status === "paused"
                              ? "bg-warning"
                              : "bg-secondary"
                          }`}
                        >
                          {cycle.status}
                        </span>
                      </td>

                      <td>
                        {cycle.started_at
                          ? new Date(
                              cycle.started_at
                            ).toLocaleDateString()
                          : "-"}
                      </td>

                      <td>
                        <div className="d-flex gap-2 flex-wrap">

                          <button
                            className="btn btn-warning btn-sm"
                            onClick={() =>
                              updateCycleAction(
                                "pause",
                                cycle.id
                              )
                            }
                          >
                            Pause
                          </button>

                          <button
                            className="btn btn-success btn-sm"
                            onClick={() =>
                              updateCycleAction(
                                "resume",
                                cycle.id
                              )
                            }
                          >
                            Resume
                          </button>

                          <button
                            className="btn btn-info btn-sm"
                            onClick={() =>
                              updateCycleAction(
                                "complete",
                                cycle.id
                              )
                            }
                          >
                            Complete
                          </button>

                          <button
                            className="btn btn-secondary btn-sm"
                            onClick={() =>
                              updateCycleAction(
                                "reset",
                                cycle.id
                              )
                            }
                          >
                            Reset
                          </button>

                          <button
                            className="btn btn-danger btn-sm"
                            onClick={() =>
                              deleteCycle(cycle.id)
                            }
                          >
                            Delete
                          </button>

                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>

              </table>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Cycles;